import React from 'react';
import { createRoot } from 'react-dom/client';
import 'normalize.css';

import './styles/global.scss';
import App from './App';

const container = document.getElementById('root');
// eslint-disable-next-line
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
